import React from 'react';
import { CTAButton } from './CTAButton';
export function IncludesSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const modules = ['creación del producto', 'estructura de oferta', 'configuración de Shopify', 'diseño base de tienda', 'vinculación de dominio', 'integración con Mercado Pago', 'Meta Ads', 'cuentas publicitarias', 'pixel y eventos', 'estructura base de campañas', 'uso de IA para acelerar implementación'];
  return <section className="py-8 md:py-12 px-4 bg-[#2E0640] pt-[50px] pb-[50px] mt-[0px] mb-[0px]" data-id="element-169">
      <div className="max-w-6xl mx-auto mt-[-30px] mb-[-30px]" data-id="element-170">
        <h2 className="text-4xl md:text-5xl font-black text-center text-[#FFFFFF] pt-[0px] pb-[0px] mt-[35px] mb-[35px]" data-id="element-171">
          ¿Qué incluye exactamente?
        </h2>

        <div className="flex justify-center mb-12" data-id="element-172">
          <img src="https://cdn.magicpatterns.com/uploads/arVKmUfcTzBbjKrBKaxKGn/mockup_dominando_shopify.png" alt="Mockup Dominando Shopify - Curso completo" className="w-full max-w-3xl rounded-2xl mt-[-23px] mb-[-23px] pt-[0px] pb-[0px]" data-id="element-173" />
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-174">
          <div className="rounded-2xl p-8 shadow-lg pt-[2px] pb-[2px] bg-[#FFFFFF] animate-neon-violet mt-[-10px] mb-[-10px]" data-id="element-175">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-176">
              ⚡Programa grabado 100% a tu ritmo.
            </h3>
            <p className="text-lg text-gray-700" data-id="element-177">
              +30 clases paso a paso para que puedas avanzar sin equivocarte.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg pt-[20px] pb-[20px] animate-neon-violet mt-[0px] mb-[0px]" data-id="element-178">
            <h3 className="font-bold text-gray-900 mb-4 text-[23px]" data-id="element-179">
              💻Consultorias grupales en vivo semanales.
            </h3>
            <p className="text-lg text-gray-700" data-id="element-180">
              Para ayudarte a implementar, resolver dudas y corregir errores.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-8 md:p-12 bg-[#2F0240] animate-neon-violet pt-[35px] pb-[35px] mt-[-20px] mb-[-20px]" data-id="element-181">
          <h3 className="font-bold mb-8 text-center text-[29px]" data-id="element-182">
            ⚡11 Módulos de Formación Práctica.
          </h3>
          <p className="mb-6 text-center text-gray-300 text-[18px]" data-id="element-183">
            Todo lo que necesitas aprender para empezar desde 0 y SIN
            EXPERIENCIA.
          </p>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-184">
            {modules.map((module, index) => <div key={index} className="flex items-center gap-3 bg-gray-800 rounded-lg p-4" data-id="element-185">
                <span className="text-green-400 text-xl font-bold" data-id="element-186">✓</span>
                <span className="text-gray-200" data-id="element-187">{module}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}